/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_5_Resend_DescInputs */

const en_privacy_section_5_resend_desc = /** @type {(inputs: Privacy_Section_5_Resend_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`email delivery for contact form submissions.`)
};

const lv_privacy_section_5_resend_desc = /** @type {(inputs: Privacy_Section_5_Resend_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-pasta piegāde kontaktformas iesniegumiem.`)
};

/**
* | output |
* | --- |
* | "email delivery for contact form submissions." |
*
* @param {Privacy_Section_5_Resend_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_5_resend_desc = /** @type {((inputs?: Privacy_Section_5_Resend_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_5_Resend_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_5_resend_desc(inputs)
	return en_privacy_section_5_resend_desc(inputs)
});